import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { TextBox } from 'components/form/TextBox/TextBox';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button/Button';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { DropDown } from 'components/form/DropDown/DropDown';
import { RadioGroup } from 'components/RadioGroup/RadioGroup';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { Image } from '../../../components/Image/Image';
import './InfoBlock.scss';

const FinancialInformationBlock = ({
  employmentList,
  chooseResidenceList,
  chooseInterestedList,
  chooseUsaCitizienList,
  bankAccountTypeList,
  totalBalanceList,
  countryList,
  postCustomerInfoToPreApprovalOneClick,
  employmentStatus,
  employmentStatusError,
  workPhone,
  workPhoneError,
  totalAnnualIncome,
  totalAnnualIncomeError,
  residence,
  monthlyRent,
  monthlyRentError,
  bankAccountType,
  bankAccountTypeError,
  residenceError,
  totalBalanceOfAccounts,
  totalBalanceOfAccountsError,
  ifOffered,
  ifOfferedError,
  isUsCitizen,
  isUsCitizenError,
  motherMaidenName,
  motherMaidenNameError,
  isCheckedTerms,
  isCheckedTermsError,
  onClickPricingAndTerms,
  onClickPrivacyPoliciy,
  onClickBankDisclaimers,
  onClickBankSecurity,
  country,
  countryError,
  setState,
  onChangeTotalAnnualIncome,
  onChangeMonthlyRent,
  onChangeMotherMaidenName,
  termsAndConditions,
}) => {
  return (
    <FlexContainer className="flex-column width100 m-margl0 margB10">
      <Label typeHeader={'h4'} className="H4 mH5 margB22 m-hide">
        Financial Information
      </Label>

      <FlexContainer className="flex-column margTop8 width100 gap-16 InfoBlock">
        <FlexContainer className="m-flex-column justify-between gap-16">
          <FlexContainer className="flex-column format100">
            <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
              Employment status
            </Label>
            <FlexContainer className={'flex-column'}>
              <DropDown
                id="employment-status"
                datatestid="prequal-flow-form-dropdown"
                list={employmentList}
                value={employmentStatus}
                onChange={value => setState({ employmentStatus: value })}
                error={employmentStatusError}
                isValueLabelBased={true}
                placeholder="Employment Status"
                fullWidth={true}
                internalPlaceholder={'Employment Status'}
              />
            </FlexContainer>
          </FlexContainer>
          <FlexContainer className="flex-column format100">
            <Label
              typeHeader={'h4'}
              className="H4 margb16 m-margb8 text-16 m-hide"
            >
              Work phone (optional)
            </Label>
            <FlexContainer className={'flex-column'}>
              <TextBox
                id="workPhone"
                name="workPhone"
                datatestid="workPhone"
                placeholder="Work phone (optional)"
                value={workPhone}
                error={workPhoneError}
                fullWidth={true}
                onChange={e => setState({ workPhone: e.target.value })}
              />
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="flex-column width100">
          <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
            Total annual income
            <FinancialToolTip
              toolTipText={
                'Include all annual income available to you, for example, current or reasonably expected salary and bonuses, tips, social security benefits, retirement and investment income. If you are 21 or older, you may also include income from others which you regularly use to pay your expenses.'
              }
            />
          </Label>
          <FlexContainer className={'flex-column'}>
            <TextBox
              id="totalAnnualIncome"
              name="totalAnnualIncome"
              datatestid="totalAnnualincome"
              placeholder="Total annual income"
              value={totalAnnualIncome}
              error={totalAnnualIncomeError}
              fullWidth={true}
              onChange={e => {
                const value = e.target.value;
                onChangeTotalAnnualIncome(value);
              }}
            />
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="flex-column width100">
          <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
            Residence
          </Label>
          <FlexContainer className={'flex-column'}>
            <RadioGroup
              radioClass="Body-1"
              customRadioGroupClass="flex-container gap-16 m-gap-48"
              onChange={value =>
                setState({ residence: value, residenceError: false })
              }
              options={chooseResidenceList}
              value={residence}
            />
            {residenceError && (
              <FlexContainer className="margT4">
                <Image className="errorCircle" />
                <Label className="errorText text-12" role={'alert'}>
                  {residenceError}
                </Label>
              </FlexContainer>
            )}
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="flex-column width100">
          <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
            Monthly rent/mortgage
          </Label>
          <FlexContainer className={'flex-column'}>
            <TextBox
              id="monthlyRent"
              name="monthlyRent"
              datatestid="monthlyRent"
              placeholder="Monthly rent/mortgage"
              value={monthlyRent}
              fullWidth={true}
              error={monthlyRentError}
              onChange={e => {
                const value = e.target.value;
                onChangeMonthlyRent(value);
              }}
            />
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="m-flex-column justify-between gap-16">
          <FlexContainer className="flex-column format100">
            <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
              Bank account type
            </Label>
            <FlexContainer className={'flex-column'}>
              <DropDown
                datatestid="bankAccountType"
                list={bankAccountTypeList}
                hideTopPlaceholder={false}
                value={bankAccountType}
                onChange={value => setState({ bankAccountType: value })}
                error={bankAccountTypeError}
                isValueLabelBased={true}
                placeholder="Back account type"
                fullWidth={true}
                internalPlaceholder={'Bank account type'}
                id="bank-account-type"
              />
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="flex-column format100">
            <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
              Total balance of accounts
            </Label>
            <FlexContainer className={'flex-column'}>
              <DropDown
                id="total-balance-accounts"
                datatestid="Total-balance-of-accounts"
                list={totalBalanceList}
                value={totalBalanceOfAccounts}
                onChange={value => setState({ totalBalanceOfAccounts: value })}
                error={totalBalanceOfAccountsError}
                isValueLabelBased={true}
                placeholder="Total balance of accounts"
                fullWidth={true}
                internalPlaceholder={'Total balance of accounts'}
              />
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="flex-column width100  ">
          <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
            If offered, would you be interested in blank checks to use for cash
            advances?
          </Label>
          <FlexContainer className={'flex-column'}>
            <RadioGroup
              radioClass="Body-1"
              customRadioGroupClass="flex-container gap-16 m-gap-48"
              onChange={value =>
                setState({ ifOffered: value, ifOfferedError: false })
              }
              options={chooseInterestedList}
              value={ifOffered}
            />
            {ifOfferedError && (
              <FlexContainer className="margT4">
                <Image className="errorCircle" />
                <Label className="errorText text-12" role={'alert'}>
                  {ifOfferedError}
                </Label>
              </FlexContainer>
            )}
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="flex-column width100  ">
          <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
            Are you a U.S. Citizen?
            <FinancialToolTip
              toolTipText={
                'Your country of citizenship is needed to confirm your identity and to comply with government regulations. Ally does not use this information in their decision.'
              }
            />
          </Label>
          <FlexContainer className={'flex-column'}>
            <RadioGroup
              radioClass="Body-1"
              customRadioGroupClass="flex-container gap-16 m-gap-48"
              onChange={value =>
                setState({ isUsCitizen: value, isUsCitizenError: false })
              }
              options={chooseUsaCitizienList}
              value={isUsCitizen}
            />
            {isUsCitizenError && (
              <FlexContainer className="margT4">
                <Image className="errorCircle" />
                <Label className="errorText text-12" role={'alert'}>
                  {isUsCitizenError}
                </Label>
              </FlexContainer>
            )}
          </FlexContainer>
        </FlexContainer>

        {!isUsCitizen && (
          <FlexContainer className="m-flex-column justify-between gap-16">
            <FlexContainer className="flex-column format100">
              <FlexContainer className={'flex-column'}>
                <DropDown
                  datatestid="bankAccountType"
                  list={countryList}
                  value={country}
                  onChange={value => setState({ country: value })}
                  error={countryError}
                  isValueLabelBased={true}
                  placeholder="Country of Citizenship"
                  fullWidth={true}
                  internalPlaceholder={'Country of Citizenship'}
                  id="country-of-citizenship"
                />
              </FlexContainer>
            </FlexContainer>

            <FlexContainer className="flex-column format100 m-hide"></FlexContainer>
          </FlexContainer>
        )}

        <FlexContainer className="flex-column width100">
          <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
            Mother's maiden name
            <FinancialToolTip
              toolTipText={
                'For the security of your Ally account, Ally may use this information to help confirm your identity when you call them.'
              }
            />
          </Label>
          <FlexContainer className={'flex-column'}>
            <TextBox
              id="lastName"
              name="lastName"
              datatestid="lastName"
              placeholder="Mother's maiden name"
              value={motherMaidenName}
              error={motherMaidenNameError}
              fullWidth={true}
              onChange={e => {
                const value = e.target.value;
                onChangeMotherMaidenName(value);
              }}
            />
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="flex-column width100 margT50 m-margT30">
          <Label
            typeHeader={'h4'}
            className="H4 mH5 margB16 m-margB8 m-text-16"
          >
            Terms and Conditions
          </Label>
          <FlexContainer>
            <Label className="text-12 termsAndConditionsLabel">
              {termsAndConditions}
            </Label>
          </FlexContainer>
        </FlexContainer>

        <FlexContainer className="margT16 align-items-start width100">
          <Checkbox
            className="margR12 pointer termCheck"
            checked={isCheckedTerms}
            onClick={e => setState({ isCheckedTerms: !isCheckedTerms })}
            error={isCheckedTermsError}
          />
          <Label>
            <span className="Body-2 text-14 mrgR2">
              I have read and agree to the Terms & Conditions above, the
            </span>
            <span
              className="otherLink text-14 fontBlue100"
              onClick={onClickPricingAndTerms}
            >
              {' '}
              Pricing and Terms
            </span>
            <span className="Body-2 text-14 mrgR2">, and the</span>
            <span
              className="otherLink text-14 fontBlue100"
              onClick={onClickPrivacyPoliciy}
            >
              {' '}
              Privacy Policy
            </span>
          </Label>
        </FlexContainer>
        <FlexContainer className="flex-column width100 align-items-center">
          <FinancialSubmitButton
            postCustomerInfoToPreApprovalOneClick={
              postCustomerInfoToPreApprovalOneClick
            }
            isCheckedTerms={isCheckedTerms}
          />
          <Label className="align-items-center margt50">
            <span
              className="otherLink text-14 fontBlue100"
              onClick={onClickBankDisclaimers}
            >
              {' '}
              Ally Bank Disclaimers
            </span>
            <span className="Body-2 text-14 mrgR2"> |</span>
            <span
              className="otherLink text-14 fontBlue100"
              onClick={onClickBankSecurity}
            >
              {' '}
              Ally Bank Online Security
            </span>
          </Label>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const FinancialToolTip = ({ toolTipText }) => {
  return (
    <CSTooltip
      vertical={'CREDIT_CARD'}
      title={toolTipText}
      isInline={true}
      className="m-fright"
    >
      <QuestionCircleOutlined
        className="fontGray300"
        style={{
          display: 'inline-block',
          position: 'relative',
          top: -3,
        }}
      />
    </CSTooltip>
  );
};

const FinancialSubmitButton = ({
  postCustomerInfoToPreApprovalOneClick,
  isCheckedTerms,
}) => {
  return (
    <Button
      name="submit"
      mrphType={!isCheckedTerms ? 'standard' : 'primary'}
      datatestid={`userReviewSubmit`}
      className="margT30 m-margT4 text-16 submitButton"
      key="submit"
      onClick={postCustomerInfoToPreApprovalOneClick}
      disable={!isCheckedTerms}
    >
      Submit Application
    </Button>
  );
};

export default FinancialInformationBlock;
